import CargoAssetFields from "./CargoAssetFields.jsx";
import PassengerAssetFields from "./PassengerAssetFields.jsx";
import PerformerCategorySelect from "./PerformerCategorySelect.jsx";
import SpecialAssetFields from "./SpecialAssetFields.jsx";

import {
  performerText,
} from "./performerCatalog.js";

// REISOR_PHASE3A_PERFORMER_ASSET_STEP_V3

export default function PerformerAssetStep({
  form,
  setForm,
  setError,
  tr,
  language,
  inputStyle,
  labelStyle,
  hintStyle,
  bodyTypeLabel,
  vehiclePhotoFile,
  vehiclePhotoPreview,
  onVehiclePhotoChange,
}) {
  const tx = (ru, uz, trText) =>
    performerText(
      language,
      ru,
      uz,
      trText
    );

  return (
    <>
      <PerformerCategorySelect
        form={form}
        setForm={setForm}
        setError={setError}
        language={language}
        inputStyle={inputStyle}
        labelStyle={labelStyle}
        hintStyle={hintStyle}
      />

      {form.performerCategory === "CARGO" ? (
        <CargoAssetFields
          form={form}
          setForm={setForm}
          setError={setError}
          tr={tr}
          inputStyle={inputStyle}
          labelStyle={labelStyle}
          bodyTypeLabel={bodyTypeLabel}
          vehiclePhotoFile={vehiclePhotoFile}
          vehiclePhotoPreview={vehiclePhotoPreview}
          onVehiclePhotoChange={onVehiclePhotoChange}
        />
      ) : null}

      {form.performerCategory === "SPECIAL" ? (
        <>
          <div style={labelStyle}>
            {tx(
              "Вид спецтехники",
              "Махсус техника тури",
              "Özel ekipman türü"
            )}
          </div>

          <SpecialAssetFields
            form={form}
            setForm={setForm}
            setError={setError}
            language={language}
          />
        </>
      ) : null}

      {form.performerCategory === "TOW" ? (
        <div
          style={{
            padding: 14,
            borderRadius: 16,
            background: "rgba(30,41,59,.82)",
            border: "1px solid #334155",
            color: "#e2e8f0",
            fontWeight: 800,
          }}
        >
          {tx(
            "Эвакуатор",
            "Эвакуатор",
            "Çekici"
          )}
        </div>
      ) : null}

      {form.performerCategory === "PASSENGER" ? (
        <PassengerAssetFields
          form={form}
          setForm={setForm}
          setError={setError}
          language={language}
          inputStyle={inputStyle}
          labelStyle={labelStyle}
        />
      ) : null}
    </>
  );
}
